import { useHomeSections, HomeSection } from './useHomeSections';

// النظام الديناميكي الموحد - home_sections فقط
export function useEffectiveHomeContent() {
  const sectionsQuery = useHomeSections();

  return {
    data: (sectionsQuery.data || []).sort((a,b)=>a.sort_order-b.sort_order),
    isLoading: sectionsQuery.isLoading,
    source: 'home_sections',
    sectionsQuery,
  };
}
